class CheckboxChoiceVisibilityManager {
  isVisible(choice, { filtered = false, selectedBadges = [], archivedFilter = false } = {}) {
    if (filtered && !choice.checked) {
      return false;
    }

    if (selectedBadges.length) {
      const hasSelectedBadge =
        choice.badges && choice.badges.some((badge) => selectedBadges.includes(badge.label.toLowerCase()));
      if (!hasSelectedBadge) {
        return false;
      }
    }

    return !choice.archived || (choice.archived && archivedFilter);
  }
}

export const checkboxChoiceVisibilityManager = new CheckboxChoiceVisibilityManager();
